<template>
  <div>
    <el-breadcrumb>
      <el-breadcrumb-item>燃烧代币分红设置</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card shadow="never" class="page-content">
      <div class="page-actions">
        <el-button type="primary" class="btn" @click="openDialog('add')"
          >新增</el-button
        >
      </div>
      <el-table :data="listData">
        <el-table-column label="交易对" prop="pair"></el-table-column>
        <el-table-column label="项目方ID" prop="projectId"></el-table-column>
        <el-table-column
          label="项目方分红比例"
          prop="projectBounsRate"
        ></el-table-column>
        <el-table-column
          label="卖单手续费率"
          prop="askFeeRate"
        ></el-table-column>
        <el-table-column
          label="买单手续费率"
          prop="bidFeeRate"
        ></el-table-column>
        <el-table-column
          label="卖单分红比例"
          prop="askBounsRate"
        ></el-table-column>
        <el-table-column
          label="买单分红比例"
          prop="bidBounsRate"
        ></el-table-column>
        <el-table-column label="上次分红时间" prop="lastBounsTime">
          <template slot-scope="scope">{{
            scope.row.lastBounsTime | moment
          }}</template>
        </el-table-column>
        <el-table-column label="创建时间" prop="createTime">
          <template slot-scope="scope">{{
            scope.row.createTime | moment
          }}</template>
        </el-table-column>
        <el-table-column label="状态" prop="status">
          <template slot-scope="scope">
            {{ scope.row.status ? '开启' : '不开启' }}
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button
              type="primary"
              icon="el-icon-edit"
              circle
              size="small"
              @click="openDialog('update', scope.row)"
            ></el-button>
            <!-- <el-button
              type="danger"
              icon="el-icon-delete"
              circle
              size="small"
              @click="handleRemove(scope.row.id)"
            ></el-button> -->
          </template>
        </el-table-column>
      </el-table>
      <pagination
        :size="size"
        :page="page"
        :total="listCount"
        @pageChanged="handleCurrentChange"
      ></pagination>
    </el-card>
    <detail-box
      ref="detail"
      @close="closeDialog"
      @edit="refreshList"
    ></detail-box>
  </div>
</template>
<script>
import './store';
import Pagination from 'components/pagination';
import DetailBox from './components/detailBox';
import { mapActions, mapState } from 'vuex';
export default {
  components: {
    Pagination,
    DetailBox
  },
  data() {
    return {
      size: 10,
      page: 1,
      total: 20
    };
  },
  computed: {
    ...mapState('pairBonus', ['listData', 'listCount', 'pagination'])
  },
  methods: {
    ...mapActions('pairBonus', ['getList']),
    openDialog(editType, editInfo) {
      if (editType == 'add') {
        this.$refs['detail'].setEditType('add');
        this.$refs['detail'].setVisible(true);
      } else if (editType == 'update') {
        this.$refs['detail'].setEditType('update');
        this.$refs['detail'].setEditInfo(JSON.parse(JSON.stringify(editInfo)));
        this.$refs['detail'].setVisible(true);
      }
    },
    refreshList(data) {
      this.getList({
        ...this.pagination,
        ...data
      });
    },
    handleCurrentChange(pageVal) {
      this.refreshList(pageVal);
    },
    closeDialog() {
      this.editInfo = {};
      this.dialogShow = false;
    }
  },
  mounted() {
    this.refreshList();
  }
};
</script>
<style lang="less" scoped></style>
